import { render } from "./CustomEdge.vue?vue&type=template&id=515fb742"
import script from "./CustomEdge.vue?vue&type=script&lang=js"
export * from "./CustomEdge.vue?vue&type=script&lang=js"

import "./CustomEdge.vue?vue&type=style&index=0&id=515fb742&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__